import type { Ref } from "vue";
import type { FiltroNotifiche, NotificaApi } from "~~/shared/data-model/notifica_api";

interface RispostaElenco {
  success?: boolean;
  error?: string;
  data?: NotificaApi[];
  totalRecords?: number;
}

/**
 * Elenco delle notifiche dell'utente per un filtro, con lo stato di caricamento di `useRichiesta` (skeleton, errore, ritenta). Si rilegge da solo quando cambia il
 * filtro, il numero di righe o `versione` dello store (lettura o archiviazione fatte altrove).
 */
export function useElencoNotifiche(filtro: Ref<FiltroNotifiche>, righe: Ref<number>) {
  const store = useNotificheStore();
  return useRichiesta<{ righe: NotificaApi[]; totale: number }>(
    async ({ authFetch }) => {
      const risposta = await authFetch<RispostaElenco>("/api/notifiche/list", {
        body: { archiviate: filtro.value === "archiviate", solo_non_lette: filtro.value === "non_lette", pagination: { rows: righe.value, page: 0 } },
      });
      // la risposta può portare `error` anche con HTTP 200
      if (!risposta?.data) throw new Error(risposta?.error ?? "notifiche");
      return { righe: risposta.data, totale: risposta.totalRecords ?? risposta.data.length };
    },
    { osserva: [filtro, righe, () => store.versione] },
  );
}
